import {defineStore} from "pinia";
import api from "../services/api.js";

export const useSettingsStore = defineStore("settings", {
    state: () => ({
        _settings: null,
        _work_status: null,
        _presales_allowed: null
    }),
    getters: {
        settings: (state) => state._settings,
        work_status: (state) => state._work_status,
        presales_allowed: (state) => state._presales_allowed,
    },
    actions: {
        async getSettings() {
            const response = await api.get('settings')
            this._settings = response.data
            this._work_status = this._settings.find(s => s.key === 'agents_online_status')
            this._presales_allowed = this._settings.find(s => s.key === 'presales_allowed')
        },
        async toggleWorkStatus(value) {
            const response = await api.post('settings/toggle-work-status', {value})
            this._work_status = response.data
        },
        async togglePresalesAllowed(value) {
            const response = await api.post('settings/toggle-presales-allowed', {value})
            this._presales_allowed = response.data
        }
    }
})
